import { render, staticRenderFns } from "./tx-quick-board.vue?vue&type=template&id=242cf4c0&scoped=true"
import script from "./tx-quick-board.vue?vue&type=script&lang=js"
export * from "./tx-quick-board.vue?vue&type=script&lang=js"
import style0 from "./tx-quick-board.vue?vue&type=style&index=0&id=242cf4c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242cf4c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('242cf4c0')) {
      api.createRecord('242cf4c0', component.options)
    } else {
      api.reload('242cf4c0', component.options)
    }
    module.hot.accept("./tx-quick-board.vue?vue&type=template&id=242cf4c0&scoped=true", function () {
      api.rerender('242cf4c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/desktop/tx-quick-board.vue"
export default component.exports